module.exports = __webpack_public_path__ + "img/6354622124092825005196554.d561e3a7.jpg";